import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MoreHorizSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MoreHorizSVG;
